module.exports = __webpack_public_path__ + "static/media/copy_black.847a1253.svg";